module.exports = __webpack_public_path__ + "static/img/associationTo.f30d36c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weChat/associationTo.png
// module id = 84Gy
// module chunks = 0